import { render } from "./TitleComponent.vue?vue&type=template&id=fe2a9c96&scoped=true"
import script from "./TitleComponent.vue?vue&type=script&lang=js"
export * from "./TitleComponent.vue?vue&type=script&lang=js"

import "./TitleComponent.vue?vue&type=style&index=0&id=fe2a9c96&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fe2a9c96"]])

export default __exports__